import { useEffect } from "react";
import NutritionPackagesPage from "@/containers/NutritionPackagesPage";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";
import * as actions from "@/redux/HealthProgramV1Reducer";

import { useAppDispatch } from "@/hooks";

const DiwaliDetoxPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      actions.getHealthLandingPageV1({
        slug: "diwalidetox",
      })
    );
  }, [dispatch]);

  const h1Text = "Diwali Detox";

  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/diwalidetox",
    title: "Diwali Detox by Shyft health",
    description:
      "Staying healthy during Diwali is difficult, have a Diwali detox with Shyft health.",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
    h1Text,
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <NutritionPackagesPage h1Text={h1Text} />
      </main>
    </>
  );
};

export default DiwaliDetoxPage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    await store.dispatch(
      dashboardActions.getRibbonData({ pathname: "diwalidetox" })
    );
    const res = await store.dispatch(
      actions.getHealthLandingPageV1({
        slug: "diwalidetox",
      })
    );
    if (!res?.payload) {
      return {
        notFound: true,
      };
    }
  }
);
